//checks position of the Next arrow and determines if it should show or hide
window.nextArrowPositionCheck = function (slick) {
    var slickNext = slick.$slider.find('.slick-next');
    if (slickNext.length > 0) {

        var slideWidth = slick.$slides[0].offsetWidth;
        var lastSlide = slick.$slider.find('.slick-slide[data-slick-index = ' + (slick.slideCount - 1) + ']');
        var lastSlidePositionEnd = lastSlide.offset().left + slideWidth;
        var slickNextPositionEnd = slickNext.offset().left + slickNext.width();

        if ((lastSlidePositionEnd < slickNextPositionEnd)) {
            //hide and disable next button along with gradient
            slickNext.attr('disabled', 'true').addClass('hidden');
        } else {
            slickNext.removeAttr('disabled').removeClass('hidden');
        }
    }
}

//Switches the slider to full-width after the first slide transition
window.fullWidthAfterSlideTransition = function (slider, currentSlide, nextSlide, containerClass) {
    var parentContainer = slider.closest(containerClass);
    if (nextSlide !== currentSlide && !parentContainer.hasClass('container-fluid')) {
        parentContainer.addClass('container-fluid').removeClass('container');
        slider.slick('resize');
    }
}